import React from "react";
import LocalSeoPage from "./LocalSeoPage";

export default function PranicHealingMontelimarPage() {
  return (
    <LocalSeoPage
      path="/pranic-healing-montelimar"
      service={{
        name: "Pranic Healing",
        slug: "pranic-healing",
        shortName: "le Pranic Healing",
        kicker: "Soin énergétique à Montélimar (Drôme)",
        h1: "Pranic Healing à Montélimar — Soin énergétique pour libérer corps et esprit",
        lead:
          "Le Pranic Healing est une technique de soin énergétique ancestrale qui rééquilibre tes chakras et nettoie ton aura. À Montélimar, je propose des séances individuelles en cabinet pour soulager stress, fatigue, douleurs émotionnelles et blocages énergétiques.",
        image: "https://www.bilan2vie.fr/og-pranic.jpg",
        priceFrom: 90,
        aboutTitle: "Qu'est-ce que le Pranic Healing ?",
        audienceTitle: "À qui s'adresse une séance de Pranic Healing à Montélimar ?",
      }}
      meta={{
        title: "Pranic Healing à Montélimar — Soin énergétique et magnétisme | Bilan 2 Vie",
        description:
          "Séances de Pranic Healing à Montélimar (Drôme) : soin énergétique sur les chakras et l'aura. Apaise stress, fatigue, douleurs et blocages émotionnels. Cabinet 20 quai du Roubion.",
        keywords:
          "Pranic Healing Montélimar, soin énergétique Drôme, magnétiseur Montélimar, soin des chakras, soin de l'aura, énergéticien Montélimar, soin pranique 26200",
      }}
      about={[
        "Le Pranic Healing est une méthode de soin énergétique fondée dans les années 1980 par Maître Choa Kok Sui, à partir de connaissances ancestrales sur l'énergie vitale (le « prana »). C'est une science précise qui considère le corps humain comme un système énergétique composé de chakras (centres d'énergie) et d'un corps éthérique (l'aura).",
        "Lors d'une séance, je ne te touche pas. Je travaille à quelques centimètres de ton corps, en nettoyant l'énergie usée et en projetant une énergie fraîche et harmonisante. Le but est de rétablir l'équilibre énergétique afin que ton corps active lui-même ses capacités d'auto-guérison.",
        "Le Pranic Healing ne remplace en aucun cas un suivi médical. Il agit en complément, sur les plans énergétique et émotionnel. Beaucoup de mes clients viennent en complément d'un traitement médical ou d'un suivi psychologique pour accélérer leur convalescence ou apaiser leur stress.",
        "À Montélimar, je reçois en cabinet privé, dans un espace calme propice à la détente. La séance dure environ 1h, et tu repars souvent avec une sensation de légèreté, d'apaisement et de clarté mentale. Les effets continuent à se déployer pendant les 48 à 72h qui suivent.",
      ]}
      audience={[
        "Tu te sens fatigué, vidé énergétiquement sans raison médicale.",
        "Tu traverses une période de stress intense ou de burn-out.",
        "Tu as des douleurs chroniques qui résistent aux traitements classiques.",
        "Tu vis une période émotionnelle difficile (deuil, séparation, anxiété).",
        "Tu sens que ton intuition est brouillée, que tu n'arrives plus à te recentrer.",
        "Tu veux préparer ton corps avant ou après une intervention médicale.",
        "Tu habites Montélimar, Pierrelatte, Bourg-Saint-Andéol, Valence, Aubenas ou ailleurs en Drôme/Ardèche.",
        "Tu cherches un magnétiseur ou un énergéticien sérieux et formé.",
      ]}
      steps={[
        {
          title: "Premier échange",
          desc:
            "Avant la séance, on discute 10 minutes de tes symptômes, de ton état émotionnel et de ce que tu cherches à libérer. Je t'explique en quoi consiste le Pranic Healing pour que tu sois pleinement informé.",
        },
        {
          title: "Diagnostic énergétique",
          desc:
            "Je scanne ton aura et tes chakras pour identifier les zones de congestion, de fuite ou de déséquilibre énergétique. C'est une étape précise qui me permet d'adapter le soin à TES besoins, pas à un protocole générique.",
        },
        {
          title: "Nettoyage & rééquilibrage",
          desc:
            "Allongé(e) habillé(e) sur une table, tu te détends pendant que je nettoie l'énergie usée et reprojette une énergie fraîche et harmonisante. Tu peux ressentir des picotements, de la chaleur, du froid ou simplement une grande détente.",
        },
        {
          title: "Stabilisation & conseils",
          desc:
            "À la fin, je verrouille les énergies pour que les bénéfices se prolongent. Je te donne des conseils simples (boire de l'eau, repos) et te suggère un protocole de retour si nécessaire (souvent 2 à 3 séances espacées de 2-3 semaines).",
        },
      ]}
      reasons={[
        "Praticien Pranic Healing certifié, formé directement à la méthode de Maître Choa Kok Sui. Spiritualité depuis 2015, métier depuis 2021.",
        "Cabinet calme et confidentiel au centre de Montélimar, 20 quai du Roubion — facile d'accès depuis l'A7 (sortie 17) et en moins de 5 min de la gare SNCF.",
        "Approche complète : avant le soin, j'effectue un tirage pour percevoir comment tu te sens, puis un second tirage pour identifier les chakras sur lesquels travailler en priorité — ainsi chaque séance est sur-mesure et ciblée.",
        "Tarifs transparents (90 € la séance), aucune obligation de revenir. Je préfère te dire « ça suffit » plutôt que de te faire revenir inutilement.",
        "Disponibilités en soirée et le week-end. Réservation en ligne 24h/24, confirmation immédiate.",
        "Confidentialité totale. Ce que tu vis pendant la séance reste entre nous.",
      ]}
      faqs={[
        {
          q: "Le Pranic Healing soigne-t-il les maladies ?",
          a: "Non, le Pranic Healing n'est pas une médecine. C'est une pratique énergétique complémentaire qui agit sur le bien-être global, le stress, les émotions et l'énergie vitale. Il ne remplace jamais un traitement médical, mais il peut considérablement améliorer la qualité de vie en complément.",
        },
        {
          q: "Est-ce que je vais ressentir quelque chose pendant la séance ?",
          a: "Chaque personne ressent différemment : picotements, chaleur, fraîcheur, vibrations, lourdeur agréable, somnolence. Certains ne ressentent « rien » de spectaculaire pendant la séance mais constatent un mieux-être net dans les heures ou jours qui suivent.",
        },
        {
          q: "Combien de séances faut-il prévoir ?",
          a: "Pour une problématique ponctuelle (stress aigu, fatigue passagère), 1 à 2 séances suffisent souvent. Pour des questions plus profondes (anxiété chronique, douleurs anciennes), un protocole de 3 à 5 séances espacées de 2-3 semaines est généralement recommandé.",
        },
        {
          q: "Le Pranic Healing fonctionne-t-il à distance ?",
          a: "Oui, le Pranic Healing peut techniquement se pratiquer à distance — l'énergie ne connaît pas la frontière. De mon côté cependant, je ne propose pas cette modalité : je préfère t'accueillir dans ma boutique-cabinet de Montélimar, où la magie du soin est amplifiée par l'ambiance, les cristaux et toute une expérience sensorielle pensée pour t'envelopper. Le résultat est nettement plus profond et marquant.",
        },
        {
          q: "Y a-t-il des contre-indications ?",
          a: "Aucune contre-indication majeure. Le Pranic Healing est doux et respectueux. Toutefois, si tu portes un pacemaker, es enceinte ou suis un traitement médical lourd, signale-le-moi avant la séance pour adapter le protocole.",
        },
        {
          q: "Faut-il croire en l'énergie pour que ça fonctionne ?",
          a: "Non. L'énergie agit indépendamment de ta croyance. Beaucoup de mes clients sont initialement sceptiques et constatent les effets dès la première séance. L'important, c'est ton ouverture à l'expérience.",
        },
      ]}
      blogCategory="Soins Énergétiques"
    />
  );
}
